import React, { useState, useEffect, useContext } from 'react';
import { Tabs, Skeleton, Card, Avatar, Descriptions, Button, Modal, Form, Input, Row, Col, Statistic, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { getAuthorizedPersonsProfile, getUser, saveChangePassword, getRegisteredStudentsCountByInstitutionId, getInstitutionById, getInstitutionsType, getPaymentsTypes, getSubscriptionsTypes } from '../../../actions';
import { Context } from '../../../defaults';
import SchoolClasses from './schoolClasses';
import SchoolTeachers from './schoolTeachers';
import SchoolStudents from './schoolStudents';
import SchoolSubjects from './schoolSubjects';
import { SecurityScanOutlined } from '@ant-design/icons';
import jwt from 'jwt-decode';

import moment from 'moment';


const { TabPane } = Tabs;
const { Meta } = Card;

const SchoolPages = () => {
    const [form] = Form.useForm();

    const [active, setActive] = useState('1');
    const { dictionary, language } = useContext(Context);
    const [loading, setLoading] = useState(false);
    const [authorizedPersons, setAuthorizedPersons] = useState({});
    const [institutionsType, setInstitutionsType] = useState();
    const [openChangePasswordModal, setOpenChangePasswordModal] = useState(false);
    const [user, setUser] = useState({});
    const [buttonDisabled, setButtonDisabled] = useState(true);
    const [institution, setInstitution] = useState({});
    const [paymentsTypes, setPaymentsTypes] = useState();
    const [subscriptionsType, setSubscriptionsType] = useState();
    const [currentStudentsCount, setCurrentStudentsCount] = useState();
    const [added, setAdded] = useState('');

    const callback = (key) => {
        setActive(key);
    }


    useEffect(() => {
        getInstitutionsType().then(({ data }) => setInstitutionsType(data));
        getPaymentsTypes().then(({ data }) => setPaymentsTypes(data));
        getSubscriptionsTypes().then(({ data }) => setSubscriptionsType(data));

        getAuthorizedPersonsProfile().then(({ data }) => {
            getInstitutionById(data.institutionId).then(res => {
                setInstitution(res.data);
            });
            getRegisteredStudentsCountByInstitutionId(data.institutionId).then(res => {
                setCurrentStudentsCount(res.data);
            })
            setAuthorizedPersons(data);
        });
        const t = localStorage.getItem('token');
        const persistedToken = jwt(t);
        if (persistedToken && persistedToken['nameid']) {
            setLoading(true);
            getUser(persistedToken['nameid']).then((res) => {
                setUser(res.data);
                setLoading(false);
            });
        }
    }, []);

    useEffect(() => {
        if (added) {
            setAdded(false)
            getAuthorizedPersonsProfile().then(({ data }) => {
                getInstitutionById(data.institutionId).then(res => {
                    setInstitution(res.data);
                });
                getRegisteredStudentsCountByInstitutionId(data.institutionId).then(res => {
                    setCurrentStudentsCount(res.data);
                })
                setAuthorizedPersons(data);
            });
            const t = localStorage.getItem('token');
            const persistedToken = jwt(t);
            if (persistedToken && persistedToken['nameid']) {
                setLoading(true);
                getUser(persistedToken['nameid']).then((res) => {
                    setUser(res.data);
                    setLoading(false);
                });
            }
        }
    }, [added]);

    const institutionType = institutionsType?.filter(x => x.id === institution.institutionTypeId);
    const paymentType = paymentsTypes?.filter(x => x.id === institution.paymentTypeId);
    const subscriptionType = subscriptionsType?.filter(x => x.id === institution.subscriptionTypeId);

    const getColor = (a, b) => {
        if ((a - b) / a > 0.5) {
            return '#b7eb8f';
        }
        else if ((a - b) / a > 0.2) {
            return '#ffe58f';
        }
        else {
            return '#cf1322';
        }
    }

    return (
        <>
            <Card
                style={{ marginTop: 16 }}
            >
                <Skeleton loading={loading} avatar active>
                    <Meta
                        avatar={
                            <Avatar size={64} icon={<UserOutlined />} />
                        }
                        title={`${dictionary?.Institution[language]}: ${authorizedPersons && authorizedPersons.institution && authorizedPersons.institution.name}`}
                        description={`${authorizedPersons.lastName} ${authorizedPersons.firstName} ${authorizedPersons.middleName}`}
                    />
                    <Descriptions title={dictionary?.AdditionalInfo[language]} bordered column={6}>
                        <Descriptions.Item label={dictionary?.Phone[language]} span={3}>{authorizedPersons.phone}</Descriptions.Item>
                        <Descriptions.Item label={dictionary?.Email[language]} span={3}>{user.email}</Descriptions.Item>
                        <Descriptions.Item label={dictionary?.UserName[language]} span={3}>{user.login}</Descriptions.Item>
                        <Descriptions.Item label={dictionary?.RegDate[language]} span={3}>{moment(user.regDate).format('DD.MM.YYYY')}</Descriptions.Item>
                        <Descriptions.Item label={dictionary?.LastChangePassDate[language]} span={3}>{user.lastChangePassDate ? moment(user.lastChangePassDate).format('DD.MM.YYYY') : ''}</Descriptions.Item>
                        <Descriptions.Item label={dictionary?.LastLoginDate[language]} span={3}>{user.lastLoginDate ? moment(user.lastLoginDate).format('DD.MM.YYYY') : ''}</Descriptions.Item>
                        <Descriptions.Item label={dictionary?.Password[language]} span={3}>
                            <Button type='dashed' icon={<SecurityScanOutlined />} onClick={() => { setOpenChangePasswordModal(true) }}>
                                {dictionary?.ChangePassword[language]}
                            </Button>
                        </Descriptions.Item>
                        <Descriptions.Item label={dictionary?.NameOfInstitution[language]} span={3}>{institution.name}</Descriptions.Item>
                        <Descriptions.Item label={dictionary?.TypeOfInstitution[language]} span={3}>{institutionType && institutionType.length > 0 && institutionType[0][`${language}Description`]}</Descriptions.Item>
                        <Descriptions.Item label={dictionary?.PaymentType[language]} span={3}>{paymentType && paymentType.length > 0 && paymentType[0][`${language}Description`]}</Descriptions.Item>
                        {
                            institution.paymentTypeId === 1 &&
                            <Descriptions.Item label={dictionary?.SubscriptionType[language]} span={3}>{subscriptionType && subscriptionType.length > 0 && subscriptionType[0].name}</Descriptions.Item>
                        }
                        {
                            institution.paymentTypeId === 2 &&
                            <Descriptions.Item label={dictionary?.NumberOfStudents[language]} span={6}>
                                {/* <Slider
                                    marks={{
                                        0: '0',
                                        [currentStudentsCount]: {
                                            style: {
                                                color: 'red',
                                            },
                                            label: <strong>{currentStudentsCount}</strong>,
                                        },
                                        [institution.studentsCount]: `${institution.studentsCount}`
                                    }}
                                    max={institution.studentsCount}
                                    style={{ width: '100%' }}
                                    disabled
                                /> */}
                                <Row gutter={16}>
                                    <Col span={8}>
                                        <Card>
                                            <Statistic
                                                title={dictionary?.NumberOfContractStudents[language]}
                                                value={institution.studentsCount}
                                            />
                                        </Card>
                                    </Col>
                                    <Col span={8}>
                                        <Card>
                                            <Statistic
                                                title={dictionary?.NumberOfRegisteredStudents[language]}
                                                value={currentStudentsCount}
                                                valueStyle={{ color: '#91d5ff' }}
                                            />
                                        </Card>
                                    </Col>
                                    <Col span={8}>
                                        <Card>
                                            <Statistic
                                                title={dictionary?.NumberOfRemainingStudents[language]}
                                                value={institution.studentsCount - currentStudentsCount}
                                                valueStyle={{ color: getColor(institution.studentsCount, currentStudentsCount) }}
                                            />
                                        </Card>
                                    </Col>
                                </Row>
                            </Descriptions.Item>
                        }

                    </Descriptions>
                </Skeleton>
            </Card>
            <Modal onOk={() => {
                const { password, rePassword } = form.getFieldsValue();
                if (password === rePassword) {
                    setLoading(true);
                    saveChangePassword({ password }).then(res => {
                        setLoading(false);
                        setOpenChangePasswordModal(false);
                        form.resetFields();
                        setAdded(true);
                        message.success(dictionary?.SuccessfullyChanged[language], { duration: 2 });
                    }).catch(() => {
                        setLoading(false);
                        form.resetFields();
                        message.error(dictionary?.SomethingWentWrong[language], { duration: 4 })
                    });
                }
                else {
                    form.validateFields();
                    message.error(dictionary?.PasswordsAreNotSame[language]);
                }
            }}
                okButtonProps={{ disabled: buttonDisabled }}
                onCancel={() => { setOpenChangePasswordModal(false) }}
                title={dictionary?.ChangePassword[language]} visible={openChangePasswordModal} >
                <Form
                    form={form}
                    style={{ marginTop: 24 }}
                    onFieldsChange={
                        () => {
                            const { password, rePassword } = form.getFieldsValue();
                            setButtonDisabled(!password || !rePassword);
                        }
                    }
                >
                    <Form.Item name='password' rules={[{ required: true, message: dictionary?.FillTheField[language] }]}>
                        <Input prefix={<LockOutlined />} type='password' placeholder={dictionary?.Password[language]} />
                    </Form.Item>
                    <Form.Item name='rePassword' rules={[{ required: true, message: dictionary?.FillTheField[language] }]}>
                        <Input prefix={<LockOutlined />} type='password' placeholder={dictionary?.RePassword[language]} />
                    </Form.Item>
                </Form >
            </Modal>
            <Tabs defaultActiveKey='1' onChange={callback}>
                <TabPane tab={dictionary?.ClassesList[language]} key='1'>
                    <SchoolClasses />
                </TabPane>
                <TabPane tab={dictionary?.TeacherList[language]} key='2'>
                    <SchoolTeachers />
                </TabPane>
                <TabPane tab={dictionary?.StudentsList[language]} key='3'>
                    <SchoolStudents />
                </TabPane>
                <TabPane tab={dictionary?.SubjectsList[language]} key='4'>
                    <SchoolSubjects />
                </TabPane>
            </Tabs>
        </>
    );
};

export default SchoolPages;